// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioSeriesVast_container__4BNLO {
  position: relative;
  transition: transform 0.3s ease-out;
}
.AudioSeriesVast_container__4BNLO:hover {
  transform: translateY(-10px) scale(1.05);
  z-index: 1;
}
.AudioSeriesVast_container__4BNLO.AudioSeriesVast_active__iBWxy {
  box-shadow: 0 0 10px rgba(255, 69, 0, 0.5);
  }
.AudioSeriesVast_hov__77asb:hover { /* IE 9 */ /* Safari 3-8 */
  transform: scale(0.9); 
}
.AudioSeriesVast_heroBanner__SwPOL {
    position: relative;
    height: 90vh;
    width: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.9)),
    url('https://i.pinimg.com/736x/a0/57/af/a057afe4ded4705c350f58f5be2521af.jpg');
    background-size: cover;
    background-position: center;
  }
  .AudioSeriesVast_heroContent__hRkqZ {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 2rem;
  }
  .AudioSeriesVast_contentWrapper__CFAMb {
    max-width: 800px;
  }
  .AudioSeriesVast_title__kZaGI {
    font-size: 3.5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 1rem;
    letter-spacing: -0.5px;
  }
  .AudioSeriesVast_des__Fy\\+rG{
    color: white;
    font-size: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* Number of lines to show */
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .AudioSeriesVast_metaInfo__Pf6EC {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #ffffff;
    font-size: 0.875rem;
    margin-bottom: 2rem;
  }
  .AudioSeriesVast_separator__v1B3N {
    opacity: 0.7;
  }
  .AudioSeriesVast_listenButton__ERgA- {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background-color: #ff0000;
    color: #ffffff;
    border: none;
    border-radius: 9999px;
    font-size: 0.875rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
   .AudioSeriesVast_listenButton__ERgA-:hover {
    background-color: #cc0000;
  }
  .AudioSeriesVast_playIcon__Huhd5 {
    font-size: 0.75rem;
  }
  
  .AudioSeriesVast_gridDiv__\\+sleZ{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    max-width: 1200px;
    margin: auto;
  }
  .AudioSeriesVast_container__4BNLO {
    position: relative;
    width: 250px;
    height: 300px;
  }
  .AudioSeriesVast_imgDiv__q-l6C {
    width: 100%;
    height: 100%;
  }
  .AudioSeriesVast_imgDiv__q-l6C img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 12px;
  }
  .AudioSeriesVast_outerText__Lrv\\+Q {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */
    color: white;
    transition: opacity 0.3s ease;
    border-radius: 12px;
  }
  .AudioSeriesVast_outerText__Lrv\\+Q:hover {
    opacity: 1;
  }
  .AudioSeriesVast_outerText__Lrv\\+Q h3 {
    color: #ffffff;
    margin-top: 12px;
    font-size: 1.5rem;
  }
 
  /* Tablets (768px or less) */
@media (max-width: 868px) {
  .AudioSeriesVast_title__kZaGI {
    font-size: 2.5rem; /* Adjust title size */
  }
  .AudioSeriesVast_heroBanner__SwPOL {
    height: 60vh; /* Make hero banner a bit smaller */
  }
  .AudioSeriesVast_gridDiv__\\+sleZ {
    grid-template-columns: repeat(2, 1fr); /* 2 columns for tablets */
    margin-left: 5rem;
  }
  .AudioSeriesVast_heroContent__hRkqZ {
    padding: 0 1rem; /* Padding adjustment */
  }
  .AudioSeriesVast_metaInfo__Pf6EC {
    font-size: 0.75rem; /* Smaller font for meta information */
    gap: 0.5rem; /* Adjust gap */
  }
}

/* Mobile (480px or less) */
@media (max-width: 480px) {
  .AudioSeriesVast_title__kZaGI {
    font-size: 2rem; /* Adjust title size */
  }
  .AudioSeriesVast_listenButton__ERgA- {
    padding: 0.5rem 1rem; /* Smaller padding for buttons */
    font-size: 0.75rem; /* Adjust button font size */
  }
  .AudioSeriesVast_heroBanner__SwPOL {
    height: 30vh; /* Make hero banner even smaller for mobile */
  }
  .AudioSeriesVast_gridDiv__\\+sleZ {
    grid-template-columns: 1fr; /* 1 column layout for mobile */
    margin-left: 5rem;
  }
  .AudioSeriesVast_container__4BNLO {
    height: 250px; /* Adjust container height for mobile */
  }
}`, "",{"version":3,"sources":["webpack://./src/AudioSeries/Components/CSS/AudioSeriesVast.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,wCAAwC;EACxC,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C;AACF,oCAC6B,SAAS,EACL,eAAe;EAC9C,qBAAqB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX;;;;kFAI8E;IAC9E,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,qBAAqB,EAAE,4BAA4B;IACnD,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,sCAAsC;EACxC;GACC;IACC,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC,EAAE,6BAA6B;IACnE,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,4BAA4B;AAC9B;EACE;IACE,iBAAiB,EAAE,sBAAsB;EAC3C;EACA;IACE,YAAY,EAAE,mCAAmC;EACnD;EACA;IACE,qCAAqC,EAAE,0BAA0B;IACjE,iBAAiB;EACnB;EACA;IACE,eAAe,EAAE,uBAAuB;EAC1C;EACA;IACE,kBAAkB,EAAE,sCAAsC;IAC1D,WAAW,EAAE,eAAe;EAC9B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe,EAAE,sBAAsB;EACzC;EACA;IACE,oBAAoB,EAAE,gCAAgC;IACtD,kBAAkB,EAAE,4BAA4B;EAClD;EACA;IACE,YAAY,EAAE,6CAA6C;EAC7D;EACA;IACE,0BAA0B,EAAE,+BAA+B;IAC3D,iBAAiB;EACnB;EACA;IACE,aAAa,EAAE,uCAAuC;EACxD;AACF","sourcesContent":[".container {\n  position: relative;\n  transition: transform 0.3s ease-out;\n}\n.container:hover {\n  transform: translateY(-10px) scale(1.05);\n  z-index: 1;\n}\n.container.active {\n  box-shadow: 0 0 10px rgba(255, 69, 0, 0.5);\n  }\n.hov:hover {\n  -ms-transform: scale(0.9); /* IE 9 */\n  -webkit-transform: scale(0.9); /* Safari 3-8 */\n  transform: scale(0.9); \n}\n.heroBanner {\n    position: relative;\n    height: 90vh;\n    width: 100%;\n    background-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0.2),\n      rgba(0, 0, 0, 0.9)),\n    url('https://i.pinimg.com/736x/a0/57/af/a057afe4ded4705c350f58f5be2521af.jpg');\n    background-size: cover;\n    background-position: center;\n  }\n  .heroContent {\n    position: relative;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 0 2rem;\n  }\n  .contentWrapper {\n    max-width: 800px;\n  }\n  .title {\n    font-size: 3.5rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 1rem;\n    letter-spacing: -0.5px;\n  }\n  .des{\n    color: white;\n    font-size: 16px;\n    display: -webkit-box;\n    -webkit-line-clamp: 3; /* Number of lines to show */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n  .metaInfo {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    color: #ffffff;\n    font-size: 0.875rem;\n    margin-bottom: 2rem;\n  }\n  .separator {\n    opacity: 0.7;\n  }\n  .listenButton {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    background-color: #ff0000;\n    color: #ffffff;\n    border: none;\n    border-radius: 9999px;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n   .listenButton:hover {\n    background-color: #cc0000;\n  }\n  .playIcon {\n    font-size: 0.75rem;\n  }\n  \n  .gridDiv{\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem;\n    max-width: 1200px;\n    margin: auto;\n  }\n  .container {\n    position: relative;\n    width: 250px;\n    height: 300px;\n  }\n  .imgDiv {\n    width: 100%;\n    height: 100%;\n  }\n  .imgDiv img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    border-radius: 12px;\n  }\n  .outerText {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */\n    color: white;\n    transition: opacity 0.3s ease;\n    border-radius: 12px;\n  }\n  .outerText:hover {\n    opacity: 1;\n  }\n  .outerText h3 {\n    color: #ffffff;\n    margin-top: 12px;\n    font-size: 1.5rem;\n  }\n \n  /* Tablets (768px or less) */\n@media (max-width: 868px) {\n  .title {\n    font-size: 2.5rem; /* Adjust title size */\n  }\n  .heroBanner {\n    height: 60vh; /* Make hero banner a bit smaller */\n  }\n  .gridDiv {\n    grid-template-columns: repeat(2, 1fr); /* 2 columns for tablets */\n    margin-left: 5rem;\n  }\n  .heroContent {\n    padding: 0 1rem; /* Padding adjustment */\n  }\n  .metaInfo {\n    font-size: 0.75rem; /* Smaller font for meta information */\n    gap: 0.5rem; /* Adjust gap */\n  }\n}\n\n/* Mobile (480px or less) */\n@media (max-width: 480px) {\n  .title {\n    font-size: 2rem; /* Adjust title size */\n  }\n  .listenButton {\n    padding: 0.5rem 1rem; /* Smaller padding for buttons */\n    font-size: 0.75rem; /* Adjust button font size */\n  }\n  .heroBanner {\n    height: 30vh; /* Make hero banner even smaller for mobile */\n  }\n  .gridDiv {\n    grid-template-columns: 1fr; /* 1 column layout for mobile */\n    margin-left: 5rem;\n  }\n  .container {\n    height: 250px; /* Adjust container height for mobile */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioSeriesVast_container__4BNLO`,
	"active": `AudioSeriesVast_active__iBWxy`,
	"hov": `AudioSeriesVast_hov__77asb`,
	"heroBanner": `AudioSeriesVast_heroBanner__SwPOL`,
	"heroContent": `AudioSeriesVast_heroContent__hRkqZ`,
	"contentWrapper": `AudioSeriesVast_contentWrapper__CFAMb`,
	"title": `AudioSeriesVast_title__kZaGI`,
	"des": `AudioSeriesVast_des__Fy+rG`,
	"metaInfo": `AudioSeriesVast_metaInfo__Pf6EC`,
	"separator": `AudioSeriesVast_separator__v1B3N`,
	"listenButton": `AudioSeriesVast_listenButton__ERgA-`,
	"playIcon": `AudioSeriesVast_playIcon__Huhd5`,
	"gridDiv": `AudioSeriesVast_gridDiv__+sleZ`,
	"imgDiv": `AudioSeriesVast_imgDiv__q-l6C`,
	"outerText": `AudioSeriesVast_outerText__Lrv+Q`
};
export default ___CSS_LOADER_EXPORT___;
